import { IsUUID, IsOptional } from 'class-validator';

export class EventsStatFocusDto {
  @IsUUID()
  @IsOptional()
  companyId?: string;

  @IsUUID()
  @IsOptional()
  eventTypeId?: string;
}
